import { lazy, Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";
import LoadingScreen from "../../../shared/components/LoadingScreen";
import AuthGuard from "../../../shared/guards/AuthGuard";
import ShopLayout from "../../../shared/layouts/shopLayout";
 

const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();

    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
            <Component {...props} />
        </Suspense>
    );
};
const ChargeStatement = Loadable(lazy(() => import('../view/ChargeStatement')));

export const ChargesRoutes = [
    // Dashboard Routes

    {
        path: 'shop-dashboard',
        element: (
            <AuthGuard>
                <ShopLayout />
            </AuthGuard>
        ),
        children: [
            { path: 'savings-account/charges', element: <ChargeStatement /> },
        ],
    },
];


